import TENANT_ID from '../config/TenantId';
/* We need to break some eslint default rules here. */
/* eslint "no-undef":   "off"                       */
/* eslint "no-console": "off"                       */
export default class Debug {
    static get isDevEnvironment() {
        return !!__DEV__;
    }
    static get isGlobalExceptionHandlerEnabled() {
        return !Debug.isDevEnvironment;
    }
    static get isReduxLoggerEnabled() {
        return false;
    }
    /**
     * Allowed usage:
     * 1. Debug.log('message')
     * 2. Debug.log('message', {key1: 'value1'})
     * 3. Debug.log('TAG', 'message')
     * 4. Debug.log('TAG', 'message', {key1: 'value1'})
     */
    static log(a, b, c, stream = console.log) {
        if (!Debug.isDevEnvironment)
            return;
        switch (arguments.length) {
            case 1:
                this.logger(null, a, null, stream);
                break;
            case 2:
                if (typeof b === 'string')
                    this.logger(a, b, null, stream);
                else
                    this.logger(null, a, b, stream);
                break;
            case 3:
            case 4:
                this.logger(a, b, c, stream);
                break;
            default:
                break;
        }
    }
    static logger(tag = null, message = '', obj = null, stream) {
        var _a;
        const e = new Error();
        const caller = (_a = e === null || e === void 0 ? void 0 : e.stack) === null || _a === void 0 ? void 0 : _a.split('\n').slice(2, 3);
        const logStr = tag === null
            ? `[${TENANT_ID}#${caller}]: ${message}`
            : `[${TENANT_ID}#${tag}#${caller}]: ${message}`;
        if (obj === null) {
            stream(logStr);
        }
        else {
            stream(logStr, obj);
        }
    }
    static error(a, b, c) {
        this.log(a, b, c, console.error);
    }
    static warn(a, b, c) {
        this.log(a, b, c, console.warn);
    }
}
//# sourceMappingURL=Debug.js.map